import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Container, Toolbar, useMediaQuery } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import GetNavigationMenuItems from 'menu-items';
import useConfig from 'hooks/useConfig';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import { IdleTimer } from 'common/IdleTimer';

// types
import { RootStateProps } from 'types/root';
import { openDrawer } from 'store/reducers/menu';
import useAuth from 'hooks/useAuth';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));

  const { container, miniDrawer } = useConfig();
  const dispatch = useDispatch();
  const { user } = useAuth();

  const menu = useSelector((state: RootStateProps) => state.menu);
  const { drawerOpen } = menu;

  const delayMinutes = parseInt(process.env.REACT_APP_AUTO_REFRESH_DELAY_MINUTES ?? "45");

  // drawer toggler
  const [open, setOpen] = useState(!miniDrawer || drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      setOpen(!matchDownLG);
      dispatch(openDrawer({ drawerOpen: !matchDownLG }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />
      {user &&
        <Drawer open={open} handleDrawerToggle={handleDrawerToggle} user={user} />
      }
      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar />
        {container && user && (
          <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
            <Breadcrumbs navigation={GetNavigationMenuItems({ user })} title titleBottom card={false} divider={false} />
            <Outlet />
          </Container>
        )}
        {!container && user && (
          <>
            <Breadcrumbs navigation={GetNavigationMenuItems({ user })} title titleBottom card={false} divider={false} />
            <Outlet />
          </>
        )}
      </Box>
      <IdleTimer delayMinutes={delayMinutes} />
    </Box>
  );
};

export default MainLayout;
